import Vue from "vue";
import {
  VApp,
  VForm,
  VTextField,
  VSelect,
  VCheckbox,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VCard,
  transitions,
} from "vuetify";
import Vuetify from "vuetify/lib/framework";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import i18n from './i18n';

Vue.use(Vuetify);

export default new Vuetify({
  components: {
    VApp,
    VForm,
    VTextField,
    VSelect,
    VCheckbox,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VCard,
    transitions,
  },
  theme: {
    themes: {
      light: {
        white:'#fff',
        primary: "#00BD73",
        themeGrey: "#EFEFEF",
        secondary: "#117443",
        secondary2light: "#FFF7EC",
        btnText: "#6A7784",
        gray: "#787878",
        green2: "#E5F8F1",
        red: "#F03737",
        red2: "#FDEBEB",
        black: "#1E1E1E",
        black2: "#E8E8E8",
        lightBlack: "#494949",
        third: "#FFA030",
        bg: "#E8E8E8",
        yellow:'#FFB443',
        thiGray:'#979797',
        yellowIcon:'#FFA520'
      },
    },
  },
  iconfont: "md",
  lang: {
    t: (key, ...params) => i18n.t(key, params),
    current: i18n.locale,
  },
});
